document.addEventListener("DOMContentLoaded", () => {
  const container = document.querySelector(".product__info-container");
  if (!container) return;

  const header = container.querySelector(".easysearch-header-holder");
  if (!header) return;

  // prevent duplicate insert
  if (!container.querySelector(".fitment-guarantee-message")) {
    const fitmentText =
      window.aklTranslations?.['products.product.fitment_guaranteed_text'] || '';

    header.insertAdjacentHTML(
      "afterend",
      `<div class="fitment-guarantee-message">
        ${fitmentText}
      </div>`
    );
  }
  
  //  PDP Fitment Check/Cross SVG
  const successSVG = `
    <svg class="akl-custom-fitment-icon" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M13.8047 3.52861C14.0651 3.78896 14.0651 4.21107 13.8047 4.47141L6.4714 11.8047C6.21105 12.0651 5.78894 12.0651 5.5286 11.8047L2.19526 8.47141C1.93491 8.21107 1.93491 7.78896 2.19526 7.52861C2.45561 7.26826 2.87772 7.26826 3.13807 7.52861L6 10.3905L12.8619 3.52861C13.1223 3.26826 13.5444 3.26826 13.8047 3.52861Z" fill="white"/>
    </svg>
  `;

  const failSVG = `
    <svg class="akl-custom-fitment-icon" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M10.9125 3.08754C11.1403 3.31535 11.1403 3.68469 10.9125 3.9125L3.91248 10.9125C3.68468 11.1403 3.31533 11.1403 3.08753 10.9125C2.85972 10.6847 2.85972 10.3153 3.08753 10.0875L10.0875 3.08754C10.3153 2.85974 10.6847 2.85974 10.9125 3.08754Z" fill="white"/>
      <path fill-rule="evenodd" clip-rule="evenodd" d="M3.08753 3.08754C3.31533 2.85974 3.68468 2.85974 3.91248 3.08754L10.9125 10.0875C11.1403 10.3153 11.1403 10.6847 10.9125 10.9125C10.6847 11.1403 10.3153 11.1403 10.0875 10.9125L3.08753 3.9125C2.85972 3.68469 2.85972 3.31535 3.08753 3.08754Z" fill="white"/>
    </svg>
  `;

  const wrapper = document.querySelector(
    '.product__info-wrapper .easysearch-block-container'
  );
  if (!wrapper) return;

  const resultsContainer = wrapper.querySelector('.easysearch-fitment-results');
  if (!resultsContainer) return;

  let lastState = null;

  function handleFitmentUI() {
    const iconContainer = resultsContainer.querySelector(
      '.easysearch-fitment-icon-holder .easysearch-fitment-icon'
    );
    if (!iconContainer) return;

    const isFail = resultsContainer.classList.contains('easysearch-fitment-fail');

    // Enforce header text if fail
      if (isFail) {
        const failHeader = resultsContainer.querySelector(
          '.easysearch-fitment-details .easysearch-fitment-header'
        );

        const vehicleEl = resultsContainer.querySelector(
          '.easysearch-fitment-params.easysearch-fitment-text'
        );

        if (failHeader && vehicleEl) {
          const vehicleText = vehicleEl.innerText.trim();

          if (vehicleText) {
            const newText = `Doesn't fit your ${vehicleText}`;

            if (failHeader.textContent !== newText) {
              console.log("Vehicle Text Found:", vehicleText);
              failHeader.textContent = newText;
            }
          }
        }
      }
      else{

        const vehicleEl = resultsContainer.querySelector(
          '.easysearch-fitment-params.easysearch-fitment-text'
        );

        const headerEl = resultsContainer.querySelector(
          '.easysearch-fitment-details .easysearch-fitment-header'
        );

        if (vehicleEl && headerEl) {
          const vehicleText = vehicleEl.innerText.trim();

          if (vehicleText) {
            const newText = `Guaranteed to Fit ${vehicleText}`;

            if (headerEl.textContent !== newText) {
              headerEl.textContent = newText;
            }
          }
        }
      }

    // Prevent unnecessary reruns
    if (lastState === isFail) return;
    lastState = isFail;

    // Remove existing SVGs inside icon container only
    iconContainer.querySelectorAll('svg').forEach(svg => svg.remove());

    iconContainer.insertAdjacentHTML(
      'beforeend',
      isFail ? failSVG : successSVG
    );
  }

  const observer = new MutationObserver(handleFitmentUI);

  observer.observe(resultsContainer, {
    attributes: true,
    attributeFilter: ['class'],
    childList: true,
    subtree: true
  });

  // Initial run
  handleFitmentUI();

  // MOVE + MODIFY OTHER RESULTS
  const otherResultsSelector =
    '.product__info-wrapper .easysearch-block-container .easysearch-fitment-holder .easysearch-fitment-other-results';

  const destinationSelector =
    '.product__info-wrapper .easysearch-block-container .easysearch-fitment-details .easysearch-fitment-params-holder';

  function moveAndModifyOtherResults() {
    const element = document.querySelector(otherResultsSelector);
    const destination = document.querySelector(destinationSelector);

    if (!element || !destination) return;

    // Move element
    if (!destination.contains(element)) {
      destination.appendChild(element);
    }

    // Change link text
    const link = element.querySelector('a');
    if (link && link.textContent !== "Find other products that fit your vehicle") {
      link.textContent = "Find other products that fit your vehicle";
    }
  }

  const moveObserver = new MutationObserver(moveAndModifyOtherResults);

  moveObserver.observe(document.body, {
    childList: true,
    subtree: true
  });

  moveAndModifyOtherResults();
});